import { QUERY_BRANCHES_PAGE_SIZE } from 'src/components/pipelines/constants';
import { Repository } from 'src/components/pipelines/models';
import authRequest from 'src/utils/fetch';

import { getBranchesUrl } from '../redux/sagas/repository';

export default function queryBranches(
  repository: Repository,
  query: string
): any {
  const url = getBranchesUrl(repository.path, {
    q: `name ~ "${query}"`,
    sort: '-target.date',
    pagelen: QUERY_BRANCHES_PAGE_SIZE,
  });
  return fetch(authRequest(url)).then(r => r.json());
}
